import React from 'react';
import ContactForm from '../components/ContactForm';
import FontAwesomeIcon from '../components/FontAwesomeIcon';

export default function Contact() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-safari-green to-safari-green/90 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 font-heading">
              Get in Touch
            </h1>
            <p className="text-xl text-gray-100">
              Ready to start planning your Uganda adventure? We're here to help create your perfect safari experience.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information & Form Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12">
              {/* Contact Information */}
              <div>
                <h2 className="text-3xl font-bold text-safari-green mb-6 font-heading">
                  Contact Information
                </h2>
                <p className="text-gray-600 mb-8">
                  Whether you have questions about our safari packages, need help planning your trip, or want to customize an itinerary, our experienced team is ready to assist you.
                </p>

                {/* Contact Cards */}
                <div className="space-y-6">
                  {/* Email */}
                  <div className="flex items-start gap-4 p-6 bg-safari-light rounded-xl hover:shadow-md transition">
                    <div className="w-12 h-12 bg-safari-gold rounded-full flex items-center justify-center flex-shrink-0">
                      <FontAwesomeIcon icon="fa-envelope" className="w-6 h-6 text-safari-green" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Email Us</h3>
                      <a href="mailto:info@shakestravel.com" className="text-safari-gold hover:text-safari-green transition block">
                        info@shakestravel.com
                      </a>
                      <a href="mailto:shakestravel23@gmail.com" className="text-safari-gold hover:text-safari-green transition block">
                        shakestravel23@gmail.com
                      </a>
                      <p className="text-sm text-gray-600 mt-2">
                        We typically respond within 24 hours
                      </p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start gap-4 p-6 bg-safari-light rounded-xl hover:shadow-md transition">
                    <div className="w-12 h-12 bg-safari-gold rounded-full flex items-center justify-center flex-shrink-0">
                      <FontAwesomeIcon icon="fa-phone" className="w-6 h-6 text-safari-green" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Call Us</h3>
                      <a href="tel:+256705718590" className="text-safari-gold hover:text-safari-green transition text-lg font-semibold block">
                        +256-705718590
                      </a>
                      <p className="text-sm text-gray-600 mt-2">
                        Available Monday - Saturday, 8am - 6pm EAT
                      </p>
                    </div>
                  </div>

                  {/* WhatsApp */}
                  <div className="flex items-start gap-4 p-6 bg-safari-light rounded-xl hover:shadow-md transition">
                    <div className="w-12 h-12 bg-safari-gold rounded-full flex items-center justify-center flex-shrink-0">
                      <FontAwesomeIcon icon="fa-whatsapp" className="w-6 h-6 text-safari-green" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">WhatsApp</h3>
                      <a
                        href="https://wa.me/256705718590"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-safari-gold hover:text-safari-green transition text-lg font-semibold block"
                      >
                        +256-705718590
                      </a>
                      <p className="text-sm text-gray-600 mt-2">
                        Chat with us instantly for quick questions
                      </p>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="flex items-start gap-4 p-6 bg-safari-light rounded-xl hover:shadow-md transition">
                    <div className="w-12 h-12 bg-safari-gold rounded-full flex items-center justify-center flex-shrink-0">
                      <FontAwesomeIcon icon="fa-location-dot" className="w-6 h-6 text-safari-green" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Our Offices</h3>
                      <p className="text-gray-700">
                        Jinja and Kampala, Uganda
                      </p>
                      <p className="text-sm text-gray-600 mt-2">
                        Perfectly positioned to serve all of Uganda
                      </p>
                    </div>
                  </div>
                </div>

                {/* Social Media */}
                <div className="mt-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Follow Us</h3>
                  <div className="flex gap-4">
                    <a
                      href="https://facebook.com/shakestravel"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 rounded-full bg-safari-green text-white flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition"
                      aria-label="Facebook"
                    >
                      <FontAwesomeIcon icon="fa-facebook" className="w-6 h-6" />
                    </a>
                    <a
                      href="https://instagram.com/shakestravel"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 rounded-full bg-safari-green text-white flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition"
                      aria-label="Instagram"
                    >
                      <FontAwesomeIcon icon="fa-instagram" className="w-6 h-6" />
                    </a>
                    <a
                      href="https://twitter.com/shakestravel"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 rounded-full bg-safari-green text-white flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition"
                      aria-label="Twitter"
                    >
                      <FontAwesomeIcon icon="fa-x-twitter" className="w-6 h-6" />
                    </a>
                    <a
                      href="https://linkedin.com/company/shakestravel"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 rounded-full bg-safari-green text-white flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition"
                      aria-label="LinkedIn"
                    >
                      <FontAwesomeIcon icon="fa-linkedin" className="w-6 h-6" />
                    </a>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div>
                <h2 className="text-3xl font-bold text-safari-green mb-6 font-heading">
                  Send Us a Message
                </h2>
                <p className="text-gray-600 mb-8">
                  Fill out the form below and we'll get back to you as soon as possible. Let us know what kind of safari experience you're dreaming of!
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-safari-green mb-12 font-heading">
              Frequently Asked Questions
            </h2>

            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  How far in advance should I book my safari?
                </h3>
                <p className="text-gray-600">
                  We recommend booking at least 3-6 months in advance, especially for gorilla trekking permits which are in high demand. However, we can often accommodate last-minute bookings depending on availability.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  What's included in your safari packages?
                </h3>
                <p className="text-gray-600">
                  Our packages typically include transportation, accommodation, park entrance fees, activities, professional guide services, and most meals. Each package page details exactly what's included and excluded.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Can you customize a safari itinerary for me?
                </h3>
                <p className="text-gray-600">
                  Absolutely! We specialize in creating custom itineraries tailored to your interests, budget, and schedule. Contact us with your preferences and we'll design the perfect safari for you.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Do I need travel insurance?
                </h3>
                <p className="text-gray-600">
                  Yes, we strongly recommend comprehensive travel insurance that covers medical emergencies, trip cancellation, and evacuation. We can help you arrange appropriate coverage.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  What payment methods do you accept?
                </h3>
                <p className="text-gray-600">
                  We accept bank transfers, credit cards, and mobile money transfers. Payment terms typically include a deposit to confirm booking with the balance due before your safari begins.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-safari-green text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4 font-heading">
            Ready to Start Planning?
          </h2>
          <p className="text-xl mb-8 text-gray-100 max-w-2xl mx-auto">
            Our team is excited to help you create unforgettable memories in Uganda. Let's start planning your adventure today!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+256705718590" className="btn-primary bg-safari-gold text-safari-green hover:bg-yellow-500">
              <FontAwesomeIcon icon="fa-phone" className="w-5 h-5 mr-2 inline" />
              Call Us Now
            </a>
            <a
              href="https://wa.me/256705718590"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white text-safari-green rounded-lg font-semibold hover:bg-gray-100 transition"
            >
              <FontAwesomeIcon icon="fa-whatsapp" className="w-5 h-5 mr-2 inline" />
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
